import { PurchaseStore } from '@/models/purchase_store';

const purchaseStores: Array<PurchaseStore> = [];

purchaseStores.push(new PurchaseStore({
  name: 'マツモトキヨシ',
  isMCC: true,
}));

purchaseStores.push(new PurchaseStore({
  name: 'ココカラファイン',
  isMCC: true,
}));

purchaseStores.push(new PurchaseStore({
  name: 'ドン・キホーテ',
  isMCC: false,
}));

purchaseStores.push(new PurchaseStore({
  name: 'イオン',
  isMCC: false,
}));

purchaseStores.push(new PurchaseStore({
  name: 'ウエルシア',
  isMCC: false,
}));

purchaseStores.push(new PurchaseStore({
  name: 'スギ薬局',
  isMCC: false,
}));

purchaseStores.push(new PurchaseStore({
  name: 'コスモス薬品',
  isMCC: false,
}));

purchaseStores.push(new PurchaseStore({
  name: 'ツルハ',
  isMCC: false,
}));

purchaseStores.push(new PurchaseStore({
  name: 'カインズ',
  isMCC: false,
}));

purchaseStores.push(new PurchaseStore({
  name: 'その他',
  isMCC: false,
}));

export default purchaseStores;
